import Papa from 'papaparse';

export const exportToCSV = (data, filename = 'export.csv') => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const formatInventoryForExport = (inventoryData) => {
  return inventoryData.map(item => ({
    'Product Name': item.productName || 'N/A',
    'Barcode': item.barcode || 'N/A',
    'Store': item.store?.name || 'N/A',
    'Beginning Balance': item.beginningBalance?.toFixed(2) || '0.00',
    'Stock In': item.stockIn?.toFixed(2) || '0.00',
    'Stock Out': item.stockOut?.toFixed(2) || '0.00',
    'Balance': item.balance?.toFixed(2) || '0.00',
    'Reorder Level': item.reOrderLevel?.toFixed(2) || '0.00',
    'Stock Status': getStockStatus(item.balance, item.reOrderLevel),
    'Last Updated': item.updatedAt ? formatDate(new Date(item.updatedAt)) : 'N/A'
  }));
};

const getStockStatus = (balance, reOrderLevel) => {
  if (balance <= 0) return 'Out of Stock';
  if (balance <= reOrderLevel) return 'Low Stock';
  return 'In Stock';
};

const formatDate = (date) => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};